<template>
	<div class="detail qjc-bg-fff">
		<h1 class="title qjc-c-dark qjc-texta-c">{{title}}</h1>
		
		<div class="sub-title qjc-texta-c qjc-fts-14 qjc-ftw-500">
			<b>来源：<span class="source">{{source}}</span></b>
			<b>时间：<span class="time">{{time}}</span></b>
			<b>阅读：<span class="read">{{read}}</span></b>
		</div>
		
		<div class="content" v-html="content">
			
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Toast } from 'vant'
	Vue.use(Toast);
	
	import { getHealthDyDetail, studyDetail } from "@/utils/axios"
	
	export default{
		name: 'dayuHealthDetail',
		data() {
			return {
				title: '--',
				source: '--',
				time: '--',
				read: 0,
				content: ''
			}
		},
		mounted() {
			this.$nextTick(() => {
				var that = this;
				
				// getHealthDyDetail(this.$route.params.id).then(res => {
				// 	console.log(res)
				// 	if(res.errno == 0){
				// 		that.title = res.data.title;
				// 		that.source = res.data.source;
				// 		that.time = res.data.gmtCreate;
				// 		that.read = res.data.sees;
				// 		that.content = res.data.content;
				// 	}else{
				// 		Toast.fail(res.errmsg);
				// 	}
				// });
				studyDetail(this.$route.params.id).then(res => {
					console.log(res)
					if(res.code == 200){
						that.title = res.data.title;
						that.source = res.data.source;
						that.time = res.data.created_at;
						that.read = res.data.read;
						that.content = res.data.content;
					}else{
						Toast.fail(res.errmsg);
					}
				});
			})
		}
	}
</script>

<style scoped>
	.detail{
		 width: 14.4rem;
		 margin: 0.2rem auto;
		 padding: 0.5rem;
		 box-shadow: 0.04rem 0 0.08rem 0 #f0f1f7;
	}
	.detail .title{
		font-size: 0.28rem;
		font-weight: 600;
	}
	.detail .sub-title{
		height: 0.48rem;
		line-height: 0.48rem;
		background-color: #F9FAFC;
		margin: 0.4rem 0;
		color: #A1A7B2;
	}
	.detail .sub-title b{
		font-weight: 400;
	}
	.detail .sub-title b:not(:last-child){
		margin-right: 0.64rem;
	}
	.detail .content{
		color: #555a66 !important;
	}
	.detail .content img{
		width: 100%;
	}
	
	::v-deep img{
	    max-width:100%;
	}
</style>
